// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineStylesApiSchema} from "./primitives.zod";

export const mantineAccordionItemPropsSchema = z.strictObject({
	styles: mantineStylesApiSchema.optional(),
});
